import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { isAnalyticsSuppressed } from '../analytics';
import { logLivePulse } from './storefrontEvents';

const PULSE_MS = 45000;

/** Periodic heartbeat so admin can show live visitors. */
export default function StorefrontLivePulseTracker() {
  const location = useLocation();
  const { token } = useAuth();

  useEffect(() => {
    if (isAnalyticsSuppressed()) return undefined;
    const path = `${location.pathname}${location.search}`;
    if (!path || path.startsWith('/admin')) return undefined;

    const send = () => {
      logLivePulse({ pagePath: path, authToken: token || null });
    };

    send();
    const interval = window.setInterval(send, PULSE_MS);

    return () => {
      window.clearInterval(interval);
    };
  }, [location.pathname, location.search, token]);

  return null;
}
